// Keep legacy footer destinations aligned with the draft's primary journeys.
const rzDraftPages = {
 '/pages/dealers-retailers':'rz-partners',
 '/pages/about':'rz-about',
 '/pages/faq':'rz-support-faq',
 '/pages/tech':'rz-evidence',
 '/pages/shipping-returns':'rz-support-shipping-and-returns'
};
document.querySelectorAll('a[href]').forEach(link=>{
 const target=new URL(link.href,location.href);
 const view=target.origin===location.origin?rzDraftPages[target.pathname]:null;
 if(view)link.href=`/?view=${view}`;
});
document.querySelectorAll('.rz-shared-header .nav-item').forEach(item=>{
 const link=item.querySelector('.nav-parent');
 const menu=item.querySelector('.nav-dropdown');
 if(!link||!menu)return;
 const open=value=>{item.classList.toggle('rz-nav-open',value);link.setAttribute('aria-expanded',String(value));};
 open(false);
 item.addEventListener('mouseenter',()=>open(true));
 item.addEventListener('mouseleave',()=>open(false));
 item.addEventListener('focusin',()=>open(true));
 item.addEventListener('focusout',e=>{if(!item.contains(e.relatedTarget))open(false);});
 item.addEventListener('keydown',e=>{if(e.key==='Escape'){link.focus();open(false);e.preventDefault();}if(e.key==='ArrowDown'&&e.target===link){open(true);menu.querySelector('a')?.focus();e.preventDefault();}});
 menu.addEventListener('click',()=>open(false));
});
